import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["mainDashboard", "content", "list", "view", "resume", "6666", "7777", "8888", "9999"]

  connect() {
    this.controllerName = `operations--products--tax-returns--achievements--dashboard`
  }

  doAchievementsDashboard() {
    var html = `<div class="row" data-${this.controllerName}-target="mainDashboard">
                  <div class="col-3 px-0" data-${this.controllerName}-target="resume" data-controller="operations--products--tax-returns--achievements--resume"></div>
                  <div class="col-6 pr-1" data-${this.controllerName}-target="list" data-controller="operations--products--tax-returns--achievements--index"></div>
                  <div class="col-3 pl-1" data-${this.controllerName}-target="view" data-controller="operations--products--tax-returns--achievements--show operations--products--tax-returns--achievements--save operations--products--tax-returns--achievements--transaction"></div>
                </div>`
    this.getControllerByIdentifier("operations--products--tax-returns--entities--show").contentTarget.innerHTML = html
  }

  getControllerByIdentifier(identifier) {
    return this.application.controllers.find(controller => {
      return controller.context.identifier === identifier;
    });
  }

  nameTarget(target) {
    return this.targets.find(target)
  }

  // new Promise(function (resolve) {
  //   resolve()
  // }).then(() => {
  // }) 

}
